import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslations from './en.json';
import urTranslations from './ur.json';

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    debug: true,
    fallbackLng: 'en', 
    resources: {
      en: enTranslations,
      ur: urTranslations,
    },
  });

export default i18next;
